import { createMuiTheme, colors } from '@material-ui/core';
import { plPL } from '@material-ui/core/locale';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#0693e3'
    },
    secondary: {
      main: '#8ed1fc'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
}, plPL);

export default theme;
